/**
 * Labstep
 *
 * @module state/reducers/helpers/entities/entityUser
 * @desc Helpers for entityUser reducer
 */

import type { Action } from 'labstep-web/models/action.model';
import { mergeByIds } from 'labstep-web/state/reducers/helpers/utils';
import { uniq } from 'lodash';

/**
 * @description Add entities in preview field
 */
export const previewFieldAdd = (
  state: any,
  action: Action,
  field: string,
): any => {
  const parents = action.payload.entities[action.meta.parentName];
  const children = action.payload.entities[action.meta.childKeyName];

  const newEntities = {
    ...parents,
  };
  for (const parentId of Object.keys(parents)) {
    for (const childId of Object.keys(children)) {
      const fieldValue = state[parentId][field] || [];
      newEntities[parentId][field] = uniq([...fieldValue, childId]);
    }
  }

  return mergeByIds(state, newEntities, action.meta.parentName);
};

/**
 * @description Remove entities from preview field
 */
export const previewFieldRemove = (
  state: any,
  action: Action,
  field: string,
): any => {
  const parents = action.payload.entities[action.meta.parentName];
  const children = action.payload.entities[action.meta.childKeyName];

  const newEntities = {
    ...parents,
  };
  for (const parentId of Object.keys(parents)) {
    for (const childId of Object.keys(children)) {
      const fieldValue = state[parentId][field] || [];
      newEntities[parentId][field] = fieldValue.filter(
        (id: number | string) => id !== (childId as number | string),
      );
    }
  }

  return mergeByIds(state, newEntities, action.meta.parentName);
};
